
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "consumeRecord",
})
export default class consumeRecord extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  
  data() {
        return {
          options1: [{
            value1: '选项1',
            label1: '待付款'
          }, {
            value1: '选项2',
            label1: '待发货'
          }, {
            value1: '选项3',
            label1: '待收货'
          }, {
            value1: '选项4',
            label1: '待品测'
          }, {
            value1: '选项5',
            label1: '已完成'
          }],
          value1: '',
		  options2: [{
		    value2: '选项1',
		    label2: '余额支付'
		  }, {
		    value2: '选项2',
		    label2: '微信支付'
		  }, {
		    value2: '选项3',
		    label2: '支付宝支付'
		  }, {
		    value2: '选项4',
		    label2: '组合支付'
		  }],
		  value2: ''
        }
    }

  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    let datas = [];
    let pageNum = 1;
    let pageSize = 20;
    let paramter = {
    	'pageNum':pageNum,
    	'pageSize':pageSize
    };
    this.$http.get("system/manage/cash/out/record", {paramter}).then((res: any) => {
    	datas = res.data.data.data.data;
    	this.tableData = datas;
    	// this.tableData = this.tableData.map(item=>{
    	// 	item.enable = item.enable == 1?true:false;
    	// 	return item;
    	// });
    	console.log('普通用户',this.tableData);
    });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }
  private balanceStateChange(value) {
	  
	  // 余额权限
	  console.log(value);
  }
  private userStateChange(value){
	  
	  // 评论权限
    console.log(value);
  }
  private onSubmit() {
    console.log(this.form);
  }
  private handleBalance(index,row){
	  
	  console.log(row);
	  this.$router.push('/User/editBalance/?id='+row.id);
  }
  private handleEdit(index,row){
  	  
  	  console.log(row);
	  this.$router.push('/User/editUser/?id='+row.id)
  }
}
